import React from 'react';
import ClassTable from '../../components/Tables/ClassTable';
import './ClassPage.css'; // Si existe

const ClassPage = () => {
  return (
    <div className="page-container">
      <ClassTable />
    </div>
  );
};
export default ClassPage;